// extracted by mini-css-extract-plugin
export var isPrintedCell = "_yg-1";
export var printerIcon = "_yg-0";